export default __webpack_public_path__ + "static/media/s15.ba2f4c60.jpg";